/**
 * Mongo programme listing collection (e.g. programmes_2025), not DSE score data.
 * Tries /programmes/year/current, then /programmes/collections/available (newest first).
 * @param {string} [baseURL='/api']
 * @returns {Promise<string|null>}
 */
export async function resolveProgrammeListingCollection(baseURL = '/api') {
    try {
        const currentRes = await fetch(`${baseURL}/programmes/year/current`);
        if (currentRes.ok) {
            const data = await currentRes.json();
            if (data.success && data.collection) {
                return data.collection;
            }
        }
    } catch (e) {
        console.warn('resolveProgrammeListingCollection: year/current failed', e);
    }
    try {
        const availRes = await fetch(`${baseURL}/programmes/collections/available`);
        if (availRes.ok) {
            const data = await availRes.json();
            if (data.success && Array.isArray(data.collections) && data.collections.length > 0) {
                return data.collections[0];
            }
        }
    } catch (e) {
        console.warn('resolveProgrammeListingCollection: collections/available failed', e);
    }
    return null;
}
